import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  placeholder: {
    height: '100%',
    width: '100%',
  },
  resultsContainer: {
    '& > *': {
      maxWidth: 'calc(100vw - 32px)',
    },
  },
});
